<!-- <div *ngIf="widgetName !=null" class="dashboard-widget-container" #refContainer [id]='widgetName+"htmlData"'> -->
    <div *ngIf="widgetName" class="dashboard-widget-container border-light radius-s white-bg p-3" [id]='widgetName+"htmlData"'>

        <div class="header-wrapper" > 
            <!-- widget details header-->
            <!-- <ng-container *ngIf="widgetDetail != null && widgetDetail !=undefined"> -->
            <ng-container *ngIf="widgetDetail  && !errorhandledashboardwidget.status">
                <div class="header-col-1" (click)="closeOptions_click()">
                    <h3 class="primary-text lighter-text mt-3 mr-0 mb-0 ml-0" >{{widgetDetail.title}}</h3>
                    <p class="mt-0 mr-0 mb-3 ml-0 secondary-text content-s">{{CustomFilterSub}}</p> 
                </div>
                <!-- more option button show/hide   !moreOptionState &&-->
                <div class="header-col-2 white-bg" *ngIf="moreOptionEnable">
                    <button class="white-bg" #moreOptionOrigin>
                        <!-- <img  *ngIf="!moreOptionState" src="assets/widgets/more-options.svg" (click)="moreOptions_click()"
                            (click)="$event.stopPropagation()"> -->
                        <img src="assets/widgets/more-options.svg" [tooltip]="moreoptiontitles[0]" class="tooltip-enable"
                            (click)="openOverlay_moreoptions_click(moreOptionRef,moreOptionOrigin)">
    
                    </button>
                </div>
                <!-- more options - refresh,download pdf, date filter, full screen and color palatte -->
                <div class="header-col-2-1"  (click)="$event.stopPropagation()">
                    <!-- more oprions in template - this is loaded when more oprions is clicked -->
                    <ng-template #moreOptionRef>
                        <!-- *ngIf="moreOptionState" (click)="$event.stopPropagation()" -->
                        <div class="more-option radius-s" #filterOrigin>
                            <div class="more-option-container radius-s primary-bg py-2 tooltip-shadow px-3">
                                <div class="icon-div "
                                    (click)="load_widgetData('refresh',sharedService.metaData.dashboard.dateFilter_default.default_fromDt,'refresh')">
                                    <img src="assets/widgets/refresh.svg" class="enable-action"
                                        [tooltip]="moreoptiontitles[1]" class="tooltip-enable" style="cursor:pointer;">
                                    
                                </div>
                                <div class="vertical-line border-light-left"></div>
                                <div class="icon-div " (click)="download_click(widgetDetail)">
                                    <img src="assets/widgets/download.svg"
                                        [ngClass]="handledashboardwidgetnodata.status ? 'disable-action':'enable-action'"
                                        [tooltip]="moreoptiontitles[2]" class="tooltip-enable">
                                    <!-- <div class="vertical-line border-light-left"></div> -->
                                </div>
                                <div class="vertical-line border-light-left"></div>
                                <div class="icon-div "   (click)="openOverlay_datefilter(dateFilterRef,filterOrigin,'datefilter')">
                                    <img *ngIf="widgetDetail.apply_default_timerange" src="assets/widgets/filter.svg"  [tooltip]="moreoptiontitles[3]" 
                                        class="enable-action tooltip-enable">
                                    <img *ngIf="!widgetDetail.apply_default_timerange" style="cursor:default;opacity: 32%" src="assets/widgets/filter.svg" [tooltip]="moreoptiontitles[3]" 
                                        class="disable-action tooltip-enable">
                                    <!-- <div class="vertical-line border-light-left"></div> -->
                                </div>
                                <div class="vertical-line border-light-left"></div>
                                <div class="icon-div" (click)="fullscreen_click(headerContent,content,subtitle)">
                                    <!-- #fullscreenOrigin -->
                                    <img src="assets/widgets/full-screen.svg"
                                        [ngClass]="handledashboardwidgetnodata.status ? 'disable-action':'enable-action'"
                                        [tooltip]="moreoptiontitles[4]" class="tooltip-enable">
                                    <!-- ,fullscreenOrigin -->
                                    <!-- <ng-container *ngIf="widgetType=='Chart'"> -->
                                    <!-- <div class="vertical-line border-light-left"></div> -->
                                </div>
                                <div class="vertical-line border-light-left"></div>
                                <div class="icon-div " #colorPalateOrigin
                                    (click)="openOverlay_color_palette(colorPalateRef,colorPalateOrigin,'colorpalate')">
                                    <img *ngIf="widgetType=='Chart' && widgetDetail.is_color_palette_enable" src="assets/widgets/edit-color.svg"
                                        [tooltip]="moreoptiontitles[5]" class="tooltip-enable"
                                        [ngClass]="handledashboardwidgetnodata.status ? 'disable-action':'enable-action'">
                                    <!-- </ng-container> -->
                                    <!-- color palatte option is disabled for Table -->
                                    <img *ngIf="widgetType=='Table' || !widgetDetail.is_color_palette_enable" style="cursor:default;opacity: 32%;"
                                        src="assets/widgets/edit-color-disable.svg" [tooltip]="moreoptiontitles[5]" class="tooltip-enable">
                                </div>
    
                            </div>
                            <div class="arrow-div m-0" >
                                <!-- <div class="arrow">
    
                                </div> -->
                                <img src="assets/widgets/play-gray.svg">
                            </div>
                            <div class="close-option">
                                <button class="icon-button p-3 tooltip-enable primary-bg radius-s tooltip-shadow" (click)="closeOptions_click()" [tooltip]="moreoptiontitles[6]">x
                                    <!-- <img class="exit-option" src="assets/widgets/close-more-options.svg" class="enable-action"
                                (click)="closeOptions_click()"> -->
                                    <!-- <img class="exit-option" src="assets/widgets/window-close-line.svg"
                                        class="enable-action" (click)="closeOptions_click()"> -->
                                </button>
                            </div>
                        </div>
                    </ng-template>
                    <!-- date filter options in a template- this is loaded when date filter option is clicked -->
                    <ng-template #dateFilterRef>
                        <div class="more-option-filter-container border-light  primary-bg radius-m lighter-text dropdown-shadow ">
                            <div class="more-option-filter">
                                
                                <div class="filter-header-wrapper radius-m primary-bg pt-6 px-6">
                                    <ul id="dateFilter" class="span-m primary-text m-0 p-0">
                                        <ng-container
                                            *ngFor="let filter of this.sharedService.metaData.dashboard.dateFilter|keyvalue : originalOrder; let i = index">
                                            <li class="li-m" (click)="load_widgetData('dateFilter',filter.value,'relativetime')">
                                                {{ filter.key }} </li>
                                        </ng-container>
                                    </ul>
                                    <!-- <hr class="horizondal-seperator border-light-bottom"> -->
                                </div>
                                <div class="seperator border-light-bottom radius-m mx-6"></div>
                                <div class="filter-body-wrapper pb-6 px-6 radius-m" >
                                    <form [formGroup]="selectTime">
                                        <div class="filter-body-row-1">
                                            <p class="primary-text content-l">From</p>
                                            <!-- <input type="date" id="start" [value]="fromDate | date : 'yyyy-MM-dd'"
                                                (input)="fromDate = $event.target.value"
                                                (change)="load_widgetData('dateFilter')"> -->
    
                                            <!-- <input class="primary-bg input-m primary-text input-border tooltip-enable border-none" type="date" id="to" formControlName="fromDate" [min]="mindate"
                                                [max]="maxdate"
                                                tooltip="{{selectTime.controls.toDate.value | date:'dd MMM yy HH:mm'}}" style="cursor:pointer;"> -->
                                                <input class="primary-bg input-m primary-text tooltip-enable border-none" type="datetime-local" id="to" formControlName="fromDate" [min]="mindate"
                                                [max]="maxdate"
                                                tooltip="{{selectTime.controls.toDate.value | date:'dd MMM yy HH:mm'}}" style="cursor:pointer;">
    
                                        </div>
                                        <div class="filter-body-row-2 ">
                                            <p class="primary-text content-l">To</p>
                                            <!-- <input type="date" id="end" [value]="toDate | date : 'yyyy-MM-dd'"
                                                (input)="toDate = $event.target.value"
                                                (change)="load_widgetData('dateFilter')"> -->
                                            <input class="primary-bg input-m primary-text tooltip-enable border-none" type="datetime-local" id="from" formControlName="toDate" [min]="mindate"
                                                [max]="maxdate"
                                                tooltip="{{selectTime.controls.toDate.value | date:'dd MMM yy HH:mm'}}"  style="cursor:pointer;">
                                          
                                        </div>
                                        <button class="apply submit"
                                        (click)="load_widgetData('dateFilter','','customtime')">Apply</button>
                                        <span class="date-validation alert-text span-s" *ngIf="selectTime.errors">
                                            {{sharedService.metaData.rule.lookbackmeta.formerrormsg.invalidtime}} </span>
                                    </form>
    
                                
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <!-- color palatte in template - this is loaded when color palatte option is clicked -->
                    <ng-template #colorPalateRef>
                        <div class="edit_color_palet primary-bg radius-m module-chip-shadow">
                            <div class="color-container primary-bg p-5 radius-s">
                                <!-- #selectedColor -->
                                <ng-container
                                    *ngFor="let colors of sharedService.metaData.dashboard.colorPalette ; let i=index">
                                    <div>
                                        <div class="color-1 p-1" [ngClass]="i==selectedColorIndex?'color-planel-highlight':''"
                                            (click)="colorPalatte_click(colors,i)">
                                            <!--  id="selectColor{{i}}" -->
                                            <ng-container *ngFor="let color of colors">
                                                <!-- <input type=color [value]="color" (click)="$e  vent.stopImmediatePropagation()"> -->
                                                <span class="pix" [ngStyle]="{'background-color': color}"></span>
                                                <!-- (colorEvent)="valuePasstochild($event)" -->
                                            </ng-container>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </ng-container>
            <ng-container *ngIf="errorhandledashboardwidget.status">
                <div></div>
                <div class="dashboard-refresh">
                    <img src="assets/widgets/refresh.svg" class="enable-action pr-4" [tooltip]="moreoptiontitles[1]" class="tooltip-enable"
                        (click)="load_widgetData('refresh',sharedService.metaData.dashboard.dateFilter_default.default_fromDt,'refresh')">
                </div>
            </ng-container>
    
        </div>
        <!-- body - table or chart is loaded , click on body will close the opened more options panel -->
        <div class="body-wrapper p-0 mt-3" (click)="closeOptions_click()" [id]='widgetName+"htmlwidget"'>
            <!-- <ng-container *ngIf="widgetDetail != null"> -->
            <ng-container *ngIf="widgetDetail && !handledashboardwidgetnodata.status && !errorhandledashboardwidget.status">
                <!-- table widget -->
                <app-display-table *ngIf="widgetType=='Table'" class="table" [headers]="widgetDetail.tableHeaders"
                    [rows]="widgetDetail.tableRows">
                </app-display-table>
                <!-- chart widget -->
                <div *ngIf="widgetType=='Chart'" echarts [id]="widgetDetail.widgetName" [options]="chartOption"
                    class="chart"></div>
            </ng-container>
            <!-- mat spinner is loaded until widget details loaded from api -->
            <!-- <ng-container *ngIf="widgetDetail == null && widgetName !=null"> -->
            <ng-container *ngIf="spinnerState">
                <mat-spinner class="spinner" diameter=20></mat-spinner>
                <!-- <img [src]="widgetImg" alt=""> -->
            </ng-container>
            <ng-container *ngIf="handledashboardwidgetnodata.status || errorhandledashboardwidget.status">
                <div class="dashboardwidget-nodata">
                    <div class="nodata-img">
                        <img src="assets/widgets/empty-data.svg">
                    </div>
                    <div>
                        <p class="m-0 content-m secondary-text">{{handledashboardwidgetnodata.status ?
                            handledashboardwidgetnodata.errmsg:errorhandledashboardwidget.errmsg}}</p>
                    </div>
                </div>
            </ng-container>
        </div>
    
    </div>
    <!-- template to load full screen -->
    <ng-template #headerContent>{{widgetDetail.title}}</ng-template>
    <!-- <ng-template #subtitle>{{widgetDetail.subTitle}}</ng-template> -->
    <ng-template #subtitle>{{CustomFilterSub}}</ng-template>
    
    <ng-template #content>
        <div class="body-wrapper" *ngIf="widgetName" >
            <app-display-table *ngIf="widgetType=='Table'" class="table" [headers]="widgetDetail.tableHeaders"
                [rows]="widgetDetail.tableRows">
            </app-display-table>
            <div  *ngIf="widgetType=='Chart'" echarts [id]="widgetDetail.widgetName + 'Template'" [options]="chartOption"
                class="chart">
            </div>
        </div>
    </ng-template>